import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/views/Main.vue'
import Login from '@/views/Login/Login.vue'
import Home from '@/views/Home.vue'
import Profilo from "@/views/Profilo/Profilo.vue"
import Timbratura from "@/views/Timbrature/Timbratura.vue"
import Calendario from '@/components/calendar/Calendario.vue'
import PasswordReset from "@/views/PasswordReset/PasswordReset.vue"

import storage from '@/services/storage.js'

Vue.use(Router)

const routerOptions = [
  {
    path: '/',
    component: Main,
    meta: {
      checkAuth: true
    },
    children: [
      {
        path: '/',
        component: Home,
        meta: {
          checkAuth: true
        },
      },
      {
        path: '/account',
        component: Profilo,
        meta: {
          checkAuth: true
        },
      },
      {
        path: '/timbratura',
        component: Timbratura,
        meta: {
          checkAuth: true
        },
      },
      {
        path: '/calendario',
        component: Calendario,
        meta: {
          checkAuth: true
        },
      }
    ]
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/passwordreset',
    component: PasswordReset,
    meta: {
      title: "Password reset"
    }
  },
  {
    path: "*", // Pagine non trovate (redirect su /)
    beforeEnter: (to, from, next) => {
      next({
        path: '/'
      })
    }
  }
]


const rou = new Router({
  mode: 'history',
  routes: routerOptions
})


rou.beforeEach((to, from, next) => {

  // Controllo se è richiesta l'autenticazione
  if (to.meta.checkAuth && !storage.checkAuth()) {

    next({
      path: '/login'
    })

    return

  }
  // Controllo pagina login
  else if (to.path == "/login" && storage.checkAuth()) {

    // Se il login è stato fatto, vado alla pagina riservata
    next({
      path: '/'
    })
    return
  }

  next();

})



export default rou;